import { Button, Grid, Stack } from "@mui/material";
import { get_selected_customerSettings, is_customerSettings_busy, setSelectedcustomerSettings } from "features/customerSettings/customerSettings-slice"
import { CustomerSettings } from "models";
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import rq from 'components/RedQuick';
import RedQuickInputTags from 'components/RedQuickInputTags';
import TitleService from "title-service";
import { store_customerSettings } from "features/customerSettings/customerSettings-service";
import { get_coherent_screen_list, store_customer_settings } from "features/auto-thunks";
import { getUserClaims } from "features/application/application-slice";
import SubCard from "ui-component/cards/SubCard";
import { get_all_coherentScreen } from "features/coherentScreen/coherentScreen-slice";
import EditableList from "./EditableList";
import LinearIndeterminate from "./LinearIndeterminate";

export default function CustomerSettingComponent(props: {}) {
    const customerSettings = useSelector(get_selected_customerSettings);
    const claims = useSelector(getUserClaims);
    const customerSettings_busy = useSelector(is_customerSettings_busy);
    const coherent_screens = useSelector(get_all_coherentScreen);
    const dispatch = useDispatch();
    const [currentCustomerSetting, setCurrentCustomerSetting] = useState<CustomerSettings | null>(null);
    const busy = customerSettings_busy;
    useEffect(() => {
        if (claims?.player) {
            dispatch(get_coherent_screen_list({
                playerId: claims?.player
            }));
        }
        if (customerSettings) {
            setCurrentCustomerSetting({
                ...customerSettings
            });
        }
        else {
            setCurrentCustomerSetting({
                blackListTags: [],
                description: '',
                domain: '',
                name: '',
                whiteListTags: [],
                coherentScreen: '',
                connectionCode: '',
                administrators: []
            })
        }
    }, [customerSettings?.id])
    return (
        <>
            <LinearIndeterminate visible={busy} />
            <Grid item xs={12}  >
                <SubCard title={TitleService('Customer Settings')}>
                    <Grid container xs={12} spacing={2}>
                        <Grid item xs={12}>
                            <rq.RedQuickTextField title={TitleService('Name')} value={currentCustomerSetting?.name || ''} onChange={(val) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    name: val
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <rq.RedQuickTextField title={TitleService('Description')} value={currentCustomerSetting?.description || ''} onChange={(val) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    description: val
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <rq.RedQuickTextField title={TitleService('Domain')} value={currentCustomerSetting?.domain || ''} onChange={(val) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    domain: val
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <rq.RedQuickTextField title={TitleService('Connection Code')} value={currentCustomerSetting?.connectionCode || ''} onChange={(val) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    connectionCode: val
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <span>Administrators</span>
                            <EditableList value={currentCustomerSetting?.administrators || []} onChange={(data) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    administrators: data
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <rq.RedQuickDropdown title={TitleService('Coherent Screen')}
                                options={coherent_screens.map((coherent_screen) => {
                                    return {
                                        label: coherent_screen.name,
                                        value: coherent_screen.id
                                    }
                                })}
                                value={currentCustomerSetting?.coherentScreen || ''} onChange={(val) => {
                                    setCurrentCustomerSetting({
                                        ...currentCustomerSetting,
                                        coherentScreen: val
                                    });
                                }} />
                        </Grid>
                        <Grid item xs={12}>
                            <span>Black list</span>
                            <RedQuickInputTags value={currentCustomerSetting?.blackListTags || []} onUpdate={(data) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    blackListTags: data
                                });
                            }} />
                        </Grid>
                        <Grid item xs={12}>
                            <span>White list</span>
                            <RedQuickInputTags value={currentCustomerSetting?.whiteListTags || []} onUpdate={(data) => {
                                setCurrentCustomerSetting({
                                    ...currentCustomerSetting,
                                    whiteListTags: data
                                });
                            }} />
                        </Grid>
                        <Grid>
                            <Stack spacing={2} direction="row">
                                <Button color="secondary" variant="contained" onClick={() => {
                                    setCurrentCustomerSetting({
                                        blackListTags: [],
                                        description: '',
                                        domain: '',
                                        name: '',
                                        whiteListTags: [],
                                        connectionCode: '',
                                        coherentScreen: ''
                                    });
                                    dispatch(setSelectedcustomerSettings(null));
                                }}>{TitleService('New')}</Button>
                                <Button color="success" variant="contained" onClick={async () => {
                                    await dispatch(store_customer_settings({
                                        customerSettings: currentCustomerSetting,
                                        playerId: claims?.player
                                    }));

                                }}>{TitleService('Save')}</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </SubCard>
            </Grid>
        </>
    )
}